"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numerologyLocales = void 0;
exports.numerologyLocales = {
    en: {
        numerologies: {
            enkanitham: 'Tamil Enkanitham',
            chaldean: 'Chaldean',
            pythagorean: 'Pythagorean',
        },
    },
    ta: {
        numerologies: {
            enkanitham: 'தமிழ் எண்கணிதம்',
            chaldean: 'கல்தீய எண்கணிதம்',
            pythagorean: 'பித்தகோரஸ் எண்கணிதம்',
        },
    },
};
//# sourceMappingURL=Locales.js.map